import React, { Component } from 'react'
import { connect } from 'react-redux'
import Travelservices from './Travelservices'

class ReisadviezenTravelservices extends Component {
  render() {
    const { config, plans, loading } = this.props;

    if (!plans)
      return null

    return (
      <Travelservices config={config} loading={loading} />
    )
  }
}

export default connect(
  (state) => ({
    plans: state.reisadviezen.plans,
    loading: state.reisadviezen.loading
  }),
  {}
)(ReisadviezenTravelservices);


// WEBPACK FOOTER //
// ./src/components/Reisadviezen/ReisadviezenTravelservices.js